<nz-upload *hasPermission="['ImportUploadCsvFile']"
	nzType="drag"
	[nzMultiple]="false"
	[nzDisabled]="uploadProgress !== undefined"
	[nzCustomRequest]="customUpload"
	[nzShowUploadList]="false"
	[nzBeforeUpload]="beforeUpload"
	nzFileType="application/zip,text/csv"
	nzAccept=".csv,.zip">
	<p class="ant-upload-drag-icon">
		<i nz-icon nzType="inbox" ></i>
	</p>
	<p class="ant-upload-text">Click or drag file to this area to upload</p>
	<p class="ant-upload-hint">Support for a csv or zip upload only.</p>
</nz-upload>
<ngb-progressbar *ngIf="uploadProgress || uploadProgress == 0" class="mb-3" [showValue]="true" type="info" [value]="uploadProgress" />

<div class="row mt-3">
	<div class="col">
		<app-table
			[downloadHeading]="'Bulk Import'"
			[downloadName]="'bulk_import'"
			[data]="results"
			[headerClass]="'table-info'"
			[columns]="columnRef"
			[loading]="loading"
			(onRowClick)="open($event)"
			(onUpdateRequired)="doFetchResults($event)"
			>
			<ng-template #cellRefCreatedAt let-row="row">
				<td>{{row.createdAt | date}}</td>
			</ng-template>
			<ng-template #cellRefSize let-row="row">
				<td class="col-number">{{formatSize(row.uploadSection?.fileSizeLabel)}}</td>
			</ng-template>
			<ng-template #cellRefTotalRecords let-row="row">
				<td class="col-number">{{formatCount(row.uploadSection?.lineCount)}}</td>
			</ng-template>
			<ng-template #cellRefStep let-row="row">
				<td>
					<div *ngIf="row.status == 'Pending'">Step 1: Uploaded</div>
					<div *ngIf="row.status == 'Uploading'">Step 1: Uploading</div>
					<div *ngIf="row.status == 'Uploaded'">Step 1: Waiting to start importing</div>

					<div *ngIf="row.status == 'Importing'">Step 2: Importing</div>
					<div *ngIf="row.status == 'Importing'">{{formatEta(row)}}</div>

					<div *ngIf="row.status == 'Encrypting'">Step 3: Encrypting</div>

					<div *ngIf="row.status == 'Processing'">Step 4: Processing</div>
					<div *ngIf="row.status == 'Processing'">{{formatEta(row)}}</div>

					<div *ngIf="row.status == 'Completed'">Step 4: Completed</div>
					<div *ngIf="row.status == 'Failed'">**Failed**</div>
				</td>
			</ng-template>


			<ng-template #cellRefProgress let-row="row">
				<td>
					<ng-container [ngSwitch]="row.status">
						<ng-container *ngSwitchCase="'Importing'" [ngTemplateOutlet]="progressBar" [ngTemplateOutletContext]="{value: row.importingSection.progressPercentage}"></ng-container>
						<ng-container *ngSwitchCase="'Processing'" [ngTemplateOutlet]="progressBar" [ngTemplateOutletContext]="{value: row.processingSection.progressPercentage}"></ng-container>
						<ng-container *ngSwitchCase="'Pending'" [ngTemplateOutlet]="progressBar" [ngTemplateOutletContext]="{value: 100}"></ng-container>
						<ng-container *ngSwitchCase="'Completed'" [ngTemplateOutlet]="progressBar" [ngTemplateOutletContext]="{value: 100}"></ng-container>
						<ng-container *ngSwitchDefault [ngTemplateOutlet]="progressBar" [ngTemplateOutletContext]="{value: 0}"></ng-container>
					</ng-container>
				</td>
			</ng-template>
			<ng-template #progressBar let-value="value">
				<div class="mini-progress">
					<i class="track"><b [style.width.%]="value"></b></i>
					{{value}}%
				</div>
			</ng-template>




			<ng-template #cellRefStatus let-row="row">
				<td>
					<span class="status-pill ok" *ngIf="row.status == 'Uploaded'">Uploaded</span>
					<span class="status-pill run" *ngIf="row.status == 'Encrypting'">Encrypting</span>
					<span class="status-pill run" *ngIf="row.status == 'Uploading'">Uploading</span>
					<span class="status-pill warn" *ngIf="row.status == 'Pending'">Pending</span>
					<span class="status-pill run" *ngIf="row.status == 'Importing'">Importing</span>
					<span class="status-pill run" *ngIf="row.status == 'Processing'">Processing</span>
					<span class="status-pill ok" *ngIf="row.status == 'Completed'">Completed</span>
					<span class="status-pill bad" *ngIf="row.status == 'Failed'">Failed</span>
				</td>
			</ng-template>
			<ng-template #cellRefCompletionEstimate let-row="row">
				<td *ngIf="row.status == 'Uploading'">
					-
				</td>
				<td *ngIf="row.status == 'Completed'">
					-
				</td>
				<td *ngIf="row.status == 'Failed'">
					-
				</td>
				<td *ngIf="row.status == 'Pending'">
					-
				</td>
				<td *ngIf="row.status == 'Uploaded'">
					-
				</td>
				<td *ngIf="row.status == 'Encrypting'">
					-
				</td>
				<td *ngIf="row.status == 'Processing' || row.status == 'Importing'">
					{{formatEta(row)}}
				</td>
			</ng-template>
		</app-table>
	</div>
</div>
